export default __webpack_public_path__ + "static/media/aliamat.ca53d380.png";